import { getSubPageTraits, getSubPageRoleTraits } from './subPageTraits';
import { subPageRef } from './consts';
import { parameterize } from '../../apiUtils';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(subPageRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          subPageUuid: '',
          showHtmlContent: true,
          icon: '<i class="wb webconnect-alarm"></i>',
          'custom-name': 'Sub Page',
          projectId: opts.projectId,
          version: opts.version,
          script: function () {
            const subPageUuid = '{[ subPageUuid ]}';
            const projectId = '{[ projectId ]}';
            const version = '{[ version ]}';
            let enableRoleHandling = '{[ enableRoleHandling ]}';
            let showHtmlContent = '{[ showHtmlContent ]}';
            if (subPageUuid && subPageUuid.length > 0) {
              const headers = {
                'Content-Type': 'application/json',
                'x-project-id': projectId,
              };
              const subPageEl = this;
              const identifyType = subPageEl.getAttribute('data-gjs-type');
              let showContent = false;
              let serverUrl = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/`;
              if (!identifyType) {
                serverUrl = getBackendServerUrl();
                showContent = true;
              }
              let subPageUUID = subPageUuid;
              enableRoleHandling = enableRoleHandling.trim();
              console.log(
                '🚀 ~ subPage ~ sub page UUID:',
                subPageUUID,
                ' ~ enable role handling value:',
                enableRoleHandling,
                ' ~ should enable role handling:',
                !!enableRoleHandling,
              );
              if (enableRoleHandling === true || enableRoleHandling === 'true') {
                let userObjString = localStorage.getItem('user');
                let user = '';
                if (userObjString && userObjString !== 'undefined') {
                  user = parseLSJSONStrToJSON('user');
                  console.log('*** ~ user:', user);
                  if (user) {
                    const { userRoles } = user;
                    const loggedInUserRole =
                      userRoles && userRoles.length === 1 ? userRoles[0] : '';
                    const roleParameterize = loggedInUserRole
                      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                        return word.toLowerCase();
                      })
                      .trim()
                      .replace(/\s+/g, '-')
                      .replace(/[^a-zA-Z0-9]+/g, '-');
                    const subPageElAttrs = subPageEl.attributes;
                    let roleSubPageUuidMap = [];
                    Array.from(subPageElAttrs).forEach(({ name, value }) => {
                      if (name.startsWith('data-rolesubPageuuid-')) {
                        if (value) {
                          const attrRole = name.split('data-rolesubPageuuid-')[1];
                          roleSubPageUuidMap.push({ role: attrRole, subPage: value });
                        } else {
                          subPageEl.removeAttribute(name);
                        }
                      }
                    });

                    console.log('🚀 ~ subPage ~ roleSubPageUuidMap:', roleSubPageUuidMap);
                    const filteredRoleSubPage = roleSubPageUuidMap.find(
                      (roleSubPage) => roleSubPage.role === roleParameterize,
                    );
                    console.log('🚀 ~ subPage ~ filteredRoleSubPage:', filteredRoleSubPage);
                    const roleSubPageUuid = filteredRoleSubPage ? filteredRoleSubPage.subPage : '';
                    if (roleSubPageUuid) {
                      subPageUUID = roleSubPageUuid;
                      console.log('🚀 ~ subPage ~ subPageUUID #2:', subPageUUID);
                    }
                  }
                }
              }
              if (typeof loadSubpageComponent !== 'undefined') {
                loadSubpageComponent(
                  projectId,
                  subPageUUID,
                  subPageEl.getAttribute('id'),
                  subPageEl,
                );
              } else {
                let url = `${serverUrl}projects/${projectId}/snippet-templates/${subPageUUID}`;
                const extra = {
                  method: 'GET',
                  headers,
                };
                showHtmlContent = showHtmlContent.trim();
                if (showContent || showHtmlContent === true || showHtmlContent === 'true') {
                  const lang = localStorage.getItem('lang');
                  url = `${url}/content${lang ? `?lang=${lang}` : ''}`;

                  console.log('🚀 ~ subPage ~ url show full content:', url);
                  fetch(url, extra)
                    .then((response) => {
                      return response.json();
                    })
                    .then((res) => {
                      if (res && res['nocode-html']) {
                        subPageEl.innerHTML =
                          res['nocode-html'] + `<style>${res['nocode-css']}</style>`;
                      }
                    });
                } else {
                  console.log('🚀 ~ subPage ~ url only show name:', url);
                  fetch(url, extra)
                    .then((response) => {
                      return response.json();
                    })
                    .then((res) => {
                      subPageEl.innerHTML = res['name'];
                    });
                }
              }
            }
          },
        },
        init() {
          getSubPageTraits(opts.projectId, opts.version, opts.labelSubPage).then((res) => {
            if (res) {
              this.addTrait(res, { at: 0 });
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Handle via User Role',
                  name: 'enableRoleHandling',
                  changeProp: 1,
                },
                { at: 1 },
              );
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Show SubPage Content',
                  name: 'showHtmlContent',
                  changeProp: 1,
                },
                { at: 2 },
              );
              const enableRoleHandling = this.get('enableRoleHandling');
              if (enableRoleHandling) {
                this.handleEnableRoleHandlingChange();
              }
            }
          });
          this.on('change:subPageUuid', this.handleSubPageChange);
          this.on('change:enableRoleHandling', this.handleEnableRoleHandlingChange);
        },
        async handleSubPageChange() {
          const subPageUuid = this.get('subPageUuid');
          this.setAttributes({ 'data-subPage-id': subPageUuid });
        },
        async handleEnableRoleHandlingChange() {
          const snippetUuid = this.get('snippetUuid');
          const enableRoleHandling = this.get('enableRoleHandling');
          this.setAttributes({ 'data-role-handling': enableRoleHandling });

          if (enableRoleHandling) {
            getSubPageRoleTraits(opts.projectId, opts.version, opts.labelSubPage).then(
              (response) => {
                if (response) {
                  response.forEach((item, key) => {
                    const { userRole, snippetOptions } = item ? item : '';
                    const { name, uuid } = userRole ? userRole : '';
                    const nameParamCase = parameterize(name);
                    if (name && uuid) {
                      this.addTrait(
                        {
                          type: 'select',
                          label: name,
                          name: `roleSubPageUuid-${nameParamCase}`,
                          changeProp: 1,
                          options: snippetOptions,
                        },
                        { at: key + 2 },
                      );
                      const roleSubPageUuid = this.get(`roleSubPageUuid-${nameParamCase}`);
                      if (roleSubPageUuid) {
                        this.addAttributes({
                          [`data-roleSubPageUuid-${nameParamCase}`]: roleSubPageUuid,
                        });
                      }
                      this.on(
                        `change:roleSubPageUuid-${nameParamCase}`,
                        this.handleRoleSubPageChange,
                      );
                    }
                  });
                }
              },
            );
          } else {
            let traitsToRemove = [];
            const traits = this.get('traits');
            traits.forEach((trait) => {
              if (trait.props().name.startsWith('roleSubPageUuid-')) {
                traitsToRemove.push(trait.props().name);
              }
            });
            const attrs = this.getAttributes();
            traitsToRemove.forEach((traitName) => {
              delete attrs[traitName.toLowerCase()];
              this.removeTrait(traitName);
            });
            this.setAttributes(attrs);
          }
        },
        async handleRoleSubPageChange() {
          Object.keys(this.changed).forEach((key) => {
            const snippetUuid = this.changed[key];
            this.addAttributes({
              [key]: snippetUuid,
              [`data-${key}`]: snippetUuid,
            });
          });
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === subPageRef)
            return { type: subPageRef };
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:subPageUuid', this.updateScript);
        this.listenTo(model, 'change:showHtmlContent', this.updateScript);
      },
    }),
  });
}
